import { useEffect, useState } from "react"
import { useSearchExercisesQuery, useGetFavoritesQuery } from "./exercisesApiSlice"
import ExerciseForUsers from "./ExerciseForUsers"
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import useAuth from '../../hooks/useAuth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faRefresh, faDumbbell, faHeart } from "@fortawesome/free-solid-svg-icons"

import {isMobileDevice} from "../../config/functions"



const ExercisesListForUsers = () => {
    useTitle('DPE: Exercises List')

    // admin only
    const { userId } = useAuth()

    // check for mobile device
    const isMobile=isMobileDevice()

    //search
    const [search, setSearch]=useState('')
    const [strSearch, setStrSearch] =useState('')
    const [type, setType]=useState('en')
    const [strType, setStrType] =useState('en')

    // get exercise data
    const {
        data: exercises,
        isLoading,
        isSuccess,
        isError,
        error
    } = useSearchExercisesQuery(
            {title:strSearch, filtertype: strType}, 
            {refetchOnMountOrArgChange: true}
        )
        
    let content
    if (isLoading) content = <PulseLoader color={"#5f788a"} />

    useEffect(() => {

        if (isError) {
            toast.error(error?.data?.message);
        }

    }, [isError, error])

    // get favorites
    const { favorites } = useGetFavoritesQuery(userId, {
        selectFromResult: ({ data }) => ({
            favorites: data?.ids.map(id => data?.entities[id])
        }),
    })
    
    

    // button actions
    const onSearchClicked= () =>{
        setcurrentPage(1)
        setStrSearch(search)
        setStrType(type)
    }

    const onAllClicked= () =>{
        setStrSearch('')
        setStrType('en')        
    }

	const onFavoriteClicked= () =>{
		// filter exercises, based on favorites
		setcurrentPage(1)
        setStrSearch(userId)
        setStrType('fav')        
	}


    // pagination: 1
    const [currentPage, setcurrentPage]= useState(1)
    const [itemsPerPage, setitemsPerPage]= useState(9)
    const updateitemsPerPage = (e) => {
        setitemsPerPage(e.target.value)
        setcurrentPage(1)
    }
    const pageSizes = [3, 6, 9, 12, 15];



    if (isSuccess) {

        const {ids} = exercises

        // pagination: 2
        const totalItems= ids.length
        const lastIndex= currentPage * itemsPerPage
        const firstIndex= lastIndex- itemsPerPage
        const currentPageItems = ids.slice(firstIndex, lastIndex)
        let lastPage =  Math.ceil(ids.length / itemsPerPage)
        const pages = []
        if (totalItems <= itemsPerPage) {
            let i=1
            pages.push(i)
            lastPage=1
        } else {
            for (let i=1 ; i < lastPage+1 ; i++){                
                pages.push(i)
            }
        }
        let prevActive= currentPage===1 ? 'page-item disabled' : 'page-item'
        let nextActive= currentPage===lastPage ? 'page-item disabled' : 'page-item'

        let tableHeaders
        if (isMobile) {
            tableHeaders=(
                <tr>
					<th>Exercise</th>
                    <th>Video</th>
                </tr>
            )
        } else {
            tableHeaders=(
                <tr>
                    <th>Exercise</th>
                    <th>Type</th>
                    <th>Bodypart</th>
                    <th>Video</th>
                </tr>
            )
        }

        let tableContent=null
        tableContent = currentPageItems.map(exerciseId => <ExerciseForUsers key={exerciseId} exerciseId={exerciseId} favorites={favorites} userId={userId} isMobile={isMobile} />)            
        
        content = (
            <section id="main_content">
                <header>
                    <div className="row">
                        <div className="col-md-8">
                            <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faDumbbell} style={{fontSize:"30px", marginRight:"5px"}} />Exercises</h1>
                        </div>
                        <div className="col-md-4 text-end mt-3">
                            {totalItems} Exercises
                        </div>
                    </div>
                </header>
                <main>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                {tableHeaders}
                            </thead>
                            <tbody>
                                {tableContent}
                            </tbody>
                        </table>
                        
                        <div className="row g-0">
                            <div className="col-md-8">
                                <ul className="pagination">
                                    <li className={prevActive}>
                                        <span className="page-link" role="button" onClick={() => setcurrentPage(currentPage-1)}>Previous</span>
                                    </li>
                                    {
                                        // Show max of 8 pages
                                        pages.length < 9 &&
                                        pages.map((page, index) =>{
                                            let clsName = currentPage-1===index ? 'page-item active' : "page-item"
                                            return(
                                                <li key={index} className = {clsName}>
                                                    <span className="page-link" role="button" onClick={() => setcurrentPage(page)}>{page}</span>
                                                </li>
                                            )
                                        })
                                    }
                                    <li className={nextActive}>
                                        <span className="page-link" role="button" onClick={() => setcurrentPage(currentPage+1)}>Next</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-3 text-end mt-2">
                                <label style={{marginRight:"10px"}}>Exercise per page</label>
                            </div>
                            <div className="col-md-1">
                                <select name="itemsPerPage" id="itemsPerPage" className="form-control  text-end" 
                                    value={itemsPerPage} 
                                    onChange={updateitemsPerPage}>
                                    {pageSizes.map((option, index) => {
                                    return (
                                        <option key={index}>
                                            {option}
                                        </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        
                        <div className="row g-0">
                            <div className="col-md-3">
                                <input type='text' className="form-control mt-2" placeholder='Search for exercises' 
                                onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <div className="col-md-2">
                                <select value={type} onChange={(e) => setType(e.target.value)} className="form-select mt-2">
                                    <option value="en">Exercise</option>
                                    <option value="et">Type</option>
                                    <option value="bp">Bodypart</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <button className="btn btn-steel m-1" onClick={onSearchClicked} title="Search"><FontAwesomeIcon icon={faSearch} /></button>
                                <button className="btn btn-steel m-1" onClick={onFavoriteClicked} title="Show Favorites"><FontAwesomeIcon icon={faHeart} /></button>
                                <button className="btn btn-steel m-1" onClick={onAllClicked} title="Show All"><FontAwesomeIcon icon={faRefresh} /></button>
                            </div>
                        </div>

                    </div>
                </main>
            </section>
        )
    }

    if (isError) {
        content = (
            <section id="main_content">
                <header>
                    <div className="row">
                        <div className="col-md-8">
                            <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faDumbbell} style={{fontSize:"30px", marginRight:"5px"}} />Exercises</h1>
                        </div>
                    </div>
                </header>
                <main>
                    <div className="row">
                        <div className="col-md-3">
                            <input type='text' className="form-control mt-2" placeholder='Search for exercises' 
                            onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                        <div className="col-md-2">
                            <select value={type} onChange={(e) => setType(e.target.value)} className="form-select mt-2">
                                <option value="en">Exercise</option>
                                <option value="et">Type</option>
                                <option value="bp">Bodypart</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-steel m-1" onClick={onSearchClicked} title="Search"><FontAwesomeIcon icon={faSearch} /></button>
                            <button className="btn btn-steel m-1" onClick={onFavoriteClicked} title="Show Favorites"><FontAwesomeIcon icon={faHeart} /></button>
                            <button className="btn btn-steel m-1" onClick={onAllClicked} title="Show All"><FontAwesomeIcon icon={faRefresh} /></button>
                        </div>
                    </div>
                </main>
            </section>
        )
    }



    return content
}
export default ExercisesListForUsers